// Plan label resolution. Legacy `pro` and `pro_2026` share display_name "Pro" —
// always show display_name to users (never the raw plan.name, which would render
// "Pro 2026"). Logic that distinguishes plans must match on plan.name instead.
export function getPlanLabel(subscription) {
  return subscription?.subscription?.plan?.display_name || 'Free';
}
